module.exports = __webpack_public_path__ + "static/media/monitoring.f095acef.svg";